import React, { useEffect, useMemo, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Layout, Modal } from 'antd';

import { authAPI } from '../services/api';

const { Content } = Layout;

function MobileLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const [me, setMe] = useState(null);

  useEffect(() => {
    let mounted = true;
    const run = async () => {
      try {
        const resp = await authAPI.me();
        if (mounted) setMe(resp?.data || null);
      } catch (e) {
        if (mounted) setMe(null);
      }
    };
    run();
    return () => {
      mounted = false;
    };
  }, []);

  const isAdmin = !!me?.is_admin;
  const roleName = String(me?.role_name || '').toUpperCase();

  const menuItems = useMemo(() => {
    if (isAdmin) {
      return [
        { key: 'master-data', label: '主数据' },
        { key: 'permissions', label: '权限' },
        { key: 'topic-records', label: '话题' },
        { key: 'trade-records', label: '实盘' },
      ];
    }

    if (roleName === 'CHECK_USER') {
      return [
        { key: 'topic-records', label: '话题' },
        { key: 'trade-records', label: '实盘' },
      ];
    }

    return [{ key: 'welcome', label: '欢迎' }];
  }, [isAdmin, roleName]);

  const activeKey = useMemo(() => {
    const p = location?.pathname || '/';
    if (p.startsWith('/dashboard')) return 'dashboard';
    if (p.startsWith('/master-data')) return 'master-data';
    if (p.startsWith('/permissions')) return 'permissions';
    if (p.startsWith('/webhooks')) return 'webhooks';
    if (p.startsWith('/trade-records')) return 'trade-records';
    if (p.startsWith('/topic-records')) return 'topic-records';
    if (p.startsWith('/welcome')) return 'welcome';
    return menuItems[0]?.key || 'welcome';
  }, [location?.pathname, menuItems]);

  const onSwitch = (nextKey) => {
    if (!nextKey || nextKey === activeKey) return;
    navigate(`/${nextKey}`);
  };

  const onLogout = () => {
    Modal.confirm({
      title: '确认退出',
      content: '确定要退出登录吗？',
      okText: '确认退出',
      cancelText: '取消',
      okButtonProps: { danger: true },
      onOk: () => {
        localStorage.removeItem('access_token');
        navigate('/login', { replace: true });
      },
    });
  };

  return (
    <Layout style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <Content style={{ padding: 12, paddingBottom: 72 }}>
        <Outlet />
      </Content>

      <div
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 20,
          height: 56,
          background: '#fff',
          borderTop: '1px solid #f0f0f0',
          display: 'flex',
          alignItems: 'stretch',
          justifyContent: 'space-around',
          paddingBottom: 'env(safe-area-inset-bottom)',
        }}
      >
        {(menuItems || []).map((it) => (
          <button
            key={it.key}
            type="button"
            onClick={() => onSwitch(it.key)}
            style={{
              flex: 1,
              border: 'none',
              background: 'transparent',
              padding: '6px 4px',
              fontSize: 13,
              fontWeight: activeKey === it.key ? 700 : 400,
              color: activeKey === it.key ? '#1677ff' : '#333',
            }}
          >
            {it.label}
          </button>
        ))}

        <button
          type="button"
          onClick={onLogout}
          style={{
            flex: 1,
            border: 'none',
            background: 'transparent',
            padding: '6px 4px',
            fontSize: 13,
            fontWeight: 400,
            color: '#ff4d4f',
          }}
        >
          退出
        </button>
      </div>
    </Layout>
  );
}

export default MobileLayout;
